import React from 'react';
import Rule from "../components/Rule/Rule";

const RulePage = () => {
  return (
    <div>
      <Rule />
    </div>
  );
};

export default RulePage;